import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': localStorage.getItem('lang'),
  },
})

const handleLogout = () => {
  window.localStorage.clear();
  const redirectUrl = encodeURI(process.env.REACT_APP_FRONT_URL);
  window.location.href = `${process.env.REACT_APP_ZAUTH_URL}/oauth/logout?continue=${redirectUrl}`;
};
instance.interceptors.response.use(
  response => {
    return response.data;
  },
  async error => {
    if (!error.response) {
      alert(error.message);
      throw error;
    }

    const { config, response: { status, data } } = error;

    switch (status) {
      case 401:
        try {
          await axios.get(
            `${process.env.REACT_APP_API_URL}/v1/auth/refresh`, // token refresh api
            { withCredentials: true }
          );
          const retry = await axios(config);
          return retry.data;
        } catch (error) {
          alert('로그인이 만료되었습니다. 다시 로그인해주세요.');
          handleLogout()
        }
        break;
      case 403:
        alert('접근 권한이 없습니다.');
        throw error;
      case 404:
        window.location.href = '/404';
        break;
      case 409:
        alert('다른 장치에서 로그인되어 연결이 해제되었습니다. 다시 로그인해 주세요.')
        handleLogout();
        break;
      case 400:
        alert('잘못된 요청입니다.');
        throw error;
      case 500:
        alert(`서버에 오류가 발생했습니다. ${data?.message ?? ''}`);
        throw error;
      default:
        alert(data?.message ?? '알 수 없는 오류가 발생했습니다.');
        throw error;
    }
  }
)

export default instance;
